<script setup lang="ts">
useSeoMeta({
  title: 'Aplikasi Kirim Paket COD Terbaik #1 Indonesia | KiriminAja',
  description:
    'Kirim paket ke seluruh Indonesia dengan pengiriman reguler KiriminAja! Ekspedisi terlengkap, bisa COD, &amp; tanpa minimum jumlah kiriman. Kirim sekarang!'
})

const { $toast } = useNuxtApp()

const isLoading = ref(false)
const formValues = ref({
  name: '',
  email: '',
  phone: '',
  description: '',
  attachments: [] as File[]
})

const formErrors = ref<{
  [key: string]: string
}>({})

const handleSubmit = async () => {
  isLoading.value = true
  formErrors.value = {}

  const formData = new FormData()
  formData.append('name', formValues.value.name)
  formData.append('email', formValues.value.email)
  formData.append('phone', formValues.value.phone)
  formData.append('description', formValues.value.description)
  formValues.value.attachments.forEach((file, idx) => {
    formData.append(`attachments[${idx}]`, file)
  })

  await $fetch('/intl-api/complaint', {
    method: 'POST',
    body: formData,
    onResponseError: (error) => {
      isLoading.value = false
      if (error.response.status === 422) {
        const errorData = error.response._data as {
          data?: {
            message?: string
            path?: string[]
          }[]
        }

        errorData.data?.forEach((err) => {
          if (!err.message || formErrors.value[err.path?.[0] || '0']) return
          formErrors.value[err.path?.[0] || '0'] = err.message
        })
      } else {
        $toast.error(
          'Terjadi kesalahan saat mengirim pengaduan. Silakan coba lagi nanti.'
        )
      }
    }
  })

  isLoading.value = false
  formValues.value = {
    name: '',
    email: '',
    phone: '',
    description: '',
    attachments: []
  }
  $toast.success(
    'Pengaduan berhasil dikirim, terima kasih atas partisipasi anda.'
  )
}
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      class="pt-10"
      title="Pengaduan"
      description="Laporanmu membantu kami melindungi pengguna dari penipuan yang mengatasnamakan KiriminAja."
      hero-image="/images/complaint_banner2.webp"
    >
      <template #action>
        <form class="flex flex-col gap-3 py-3" @submit.prevent="handleSubmit">
          <div class="flex flex-col gap-3">
            <UiInputControl label="Nama" for="name" required>
              <UiInputField
                id="name"
                v-model="formValues.name"
                placeholder="Masukkan Nama"
                required
              />
              <UiLabelErrorLabel
                v-if="formErrors['name']"
                :text="formErrors['name']"
              />
            </UiInputControl>
            <div class="grid grid-cols-2 gap-3">
              <UiInputControl label="Email" for="email" required>
                <UiInputField
                  id="email"
                  v-model="formValues.email"
                  placeholder="Masukkan Email"
                  required
                />
                <UiLabelErrorLabel
                  v-if="formErrors['email']"
                  :text="formErrors['email']"
                />
              </UiInputControl>
              <UiInputControl label="Nomor Telepon" for="phone" required>
                <UiInputFieldPhone
                  id="phone"
                  v-model="formValues.phone"
                  placeholder="8XXXXXXXXX"
                  :max-length="15"
                  required
                />
                <UiLabelErrorLabel
                  v-if="formErrors['phone']"
                  :text="formErrors['phone']"
                />
              </UiInputControl>
            </div>
            <UiInputControl
              label="Deskripsi Pengaduan"
              for="description"
              required
            >
              <UiInputTextArea
                id="description"
                v-model="formValues.description"
                placeholder="Tuliskan kronologi dengan jelas, media transaksi, nominal kerugian, dan informasi detail lainnya."
                required
              />
              <UiLabelErrorLabel
                v-if="formErrors['description']"
                :text="formErrors['description']"
              />
            </UiInputControl>
            <UiInputControl label="Unggah Lampiran Pengaduan" required>
              <UiInputFileDropable
                v-model="formValues.attachments"
                multiple
                additional-label="Format File: JPG, JPEG, PNG, PDF, MOV, MP4, Ukuran File Max 10 MB. Maksimal 5 File"
                :max-files="5"
              />
              <UiLabelErrorLabel
                v-if="formErrors['attachments']"
                :text="formErrors['attachments']"
              />
            </UiInputControl>
          </div>
          <div class="flex">
            <UiButton
              label="Kirim Pengaduan"
              type="submit"
              :loading="isLoading"
            />
          </div>
        </form>
      </template>
    </HeroBase>
    <CtaSection />
  </div>
</template>
